import React from 'react'
import { isChunkLoadError } from '../utils/lazyWithReload'

export default class ChunkErrorBoundary extends React.Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[ChunkErrorBoundary]', error, info)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    if (!isChunkLoadError(error)) throw error

    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: 'var(--bg-base)' }}>
        <section role="alert" style={{ maxWidth: 480, textAlign: 'center', color: 'var(--text-primary)' }}>
          <h1 style={{ fontSize: 22, marginBottom: 10 }}>Yeni sürüm hazır</h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 18 }}>
            Sayfa dosyaları güncellendi. Devam etmek için sayfayı yenileyin.
          </p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </button>
        </section>
      </main>
    )
  }
}
